export default __webpack_public_path__ + "static/media/solid.900ca690.png";